/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { stepProgressSchema } from './pipeline-status-schema';

export const stepCountSchema = z.object({
  ranAt: z.number().nullable(),
  count: z.number(),
});

export type IStepCount = z.infer<typeof stepCountSchema>;

export const stepPlainCountSchema = z.object({
  count: z.number(),
});

export type IStepPlainCount = z.infer<typeof stepPlainCountSchema>;

export const stepRejectedSchema = z.object({
  clip: z.number(),
  challenge: z.number(),
});

export type IStepRejected = z.infer<typeof stepRejectedSchema>;

export const collectionPipelineStatusV3Schema = z.object({
  collectionId: z.number(),
  slug: z.string(),
  subtitleId: z.number().nullable(),
  title: z.string(),
  parentId: z.number().nullable(),
  type: z.string(),
  status: z.string(),
  collectionPath: z.string(),
  vaultPath: z.string().nullable(),
  subtitleStatus: z.string().nullable(),
  steps: z.object({
    srtImported: z.boolean(),
    matched: stepCountSchema,
    grammar: stepCountSchema,
    extracted: stepCountSchema,
    clipped: stepCountSchema,
    clipsManual: stepPlainCountSchema,
    clipsMissing: stepPlainCountSchema,
    populated: stepProgressSchema,
    translated: stepProgressSchema,
    published: stepProgressSchema,
    clipsCropped: stepProgressSchema,
    clipsRejected: stepRejectedSchema,
    clipsUploaded: stepProgressSchema,
    triaged: stepProgressSchema.optional(),
  }),
});

export type ICollectionPipelineStatusV3 = z.infer<typeof collectionPipelineStatusV3Schema>;
